import cx from 'classnames'
import styles from './ErrorMessage.module.scss'

export const ErrorMessage = ({
  message,
  type = 'warn',
}: {
  message: string
  type?: 'warn' | 'error'
}) => <div className={cx(styles.message, styles[type])}>{message}</div>
